(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4644],{

/***/ 44267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardContent_CardContent; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(15463);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(45154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(22104);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/cardContentClasses.js


function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/CardContent.js
'use client';



const _excluded = ["className", "component"];








const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};
const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardContent'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);

/***/ }),

/***/ 21214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Container_Container; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/capitalize/capitalize.js
var capitalize = __webpack_require__(97115);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(22104);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(15463);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/useThemeProps/useThemeProps.js
var useThemeProps = __webpack_require__(31607);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(57874);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/createTheme/createTheme.js + 3 modules
var createTheme = __webpack_require__(46567);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/Container/createContainer.js


const _excluded = ["className", "component", "disableGutters", "fixed", "maxWidth", "classes"];








const defaultTheme = (0,createTheme/* default */.Z)();
const defaultCreateStyledComponent = (0,styled/* default */.Z)('div', {
  name: 'MuiContainer',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`maxWidth${(0,capitalize/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
  }
});
const useThemePropsDefault = inProps => (0,useThemeProps/* default */.Z)({
  props: inProps,
  name: 'MuiContainer',
  defaultTheme
});
const useUtilityClasses = (ownerState, componentName) => {
  const getContainerUtilityClass = slot => {
    return (0,generateUtilityClass/* default */.Z)(componentName, slot);
  };
  const {
    classes,
    fixed,
    disableGutters,
    maxWidth
  } = ownerState;
  const slots = {
    root: ['root', maxWidth && `maxWidth${(0,capitalize/* default */.Z)(String(maxWidth))}`, fixed && 'fixed', disableGutters && 'disableGutters']
  };
  return (0,composeClasses/* default */.Z)(slots, getContainerUtilityClass, classes);
};
function createContainer(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent,
    useThemeProps = useThemePropsDefault,
    componentName = 'MuiContainer'
  } = options;
  const ContainerRoot = createStyledComponent(({
    theme,
    ownerState
  }) => (0,esm_extends/* default */.Z)({
    width: '100%',
    marginLeft: 'auto',
    boxSizing: 'border-box',
    marginRight: 'auto',
    display: 'block'
  }, !ownerState.disableGutters && {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }
  }), ({
    theme,
    ownerState
  }) => ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey) => {
    const breakpoint = breakpointValueKey;
    const value = theme.breakpoints.values[breakpoint];
    if (value !== 0) {
      // @ts-ignore
      acc[theme.breakpoints.up(breakpoint)] = {
        maxWidth: `${value}${theme.breakpoints.unit}`
      };
    }
    return acc;
  }, {}), ({
    theme,
    ownerState
  }) => (0,esm_extends/* default */.Z)({}, ownerState.maxWidth === 'xs' && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up('xs')]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }
  }, ownerState.maxWidth &&
  // @ts-ignore module augmentation fails if custom breakpoints are used
  ownerState.maxWidth !== 'xs' && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up(ownerState.maxWidth)]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
    }
  }));
  const Container = /*#__PURE__*/react.forwardRef(function Container(inProps, ref) {
    const props = useThemeProps(inProps);
    const {
        className,
        component = 'div',
        disableGutters = false,
        fixed = false,
        maxWidth = 'lg'
      } = props,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    const ownerState = (0,esm_extends/* default */.Z)({}, props, {
      component,
      disableGutters,
      fixed,
      maxWidth
    });

    // @ts-ignore module augmentation fails if custom breakpoints are used
    const classes = useUtilityClasses(ownerState, componentName);
    return (
      /*#__PURE__*/
      // @ts-ignore theme is injected by the styled util
      (0,jsx_runtime.jsx)(ContainerRoot, (0,esm_extends/* default */.Z)({
        as: component
        // @ts-ignore module augmentation fails if custom breakpoints are used
        ,
        ownerState: ownerState,
        className: (0,clsx/* default */.Z)(classes.root, className),
        ref: ref
      }, other))
    );
  });
   false ? 0 : void 0;
  return Container;
}
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var utils_capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styles_styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var styles_useThemeProps = __webpack_require__(71657);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Container/Container.js
'use client';






const Container = createContainer({
  createStyledComponent: (0,styles_styled/* default */.ZP)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [styles.root, styles[`maxWidth${(0,utils_capitalize/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
    }
  }),
  useThemeProps: inProps => (0,styles_useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiContainer'
  })
});
 false ? 0 : void 0;
/* harmony default export */ var Container_Container = (Container);

/***/ }),

/***/ 8653:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cinemas",
      function () {
        return __webpack_require__(60240);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CardComponent */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44267);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62023);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83321);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(44012);
/* harmony import */ var _constants_prefetch__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86650);
/* harmony import */ var _icon_location__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16504);
/* harmony import */ var _image_box_future__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58718);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43795);
/* harmony import */ var _logic_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7663);









var CardComponent = function(cardProps) {
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var ref = (0,_logic_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useCity */ .hA)(), browserCityId = ref.cityId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        component: "article",
        sx: {
            background: theme.palette.layout.bgSecondary,
            boxShadow: theme.customShadows.cardShadow,
            borderRadius: "25px",
            height: "100%",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                img: cardProps === null || cardProps === void 0 ? void 0 : cardProps.image,
                title: (cardProps === null || cardProps === void 0 ? void 0 : cardProps.alt) || (cardProps === null || cardProps === void 0 ? void 0 : cardProps.name),
                layout: "intrinsic",
                objectFit: "cover",
                width: "524px",
                height: "294px",
                sx: {
                    borderRadius: "20px",
                    overflow: "hidden"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                sx: {
                    p: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(24)
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        gutterBottom: true,
                        component: "h3",
                        sx: {
                            fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(28),
                            mb: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(16),
                            fontWeight: 700,
                            display: "-webkit-box",
                            WebkitLineClamp: "1",
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        children: cardProps === null || cardProps === void 0 ? void 0 : cardProps.name
                    }),
                    cardProps.logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        img: cardProps === null || cardProps === void 0 ? void 0 : cardProps.logo,
                        title: "".concat((cardProps === null || cardProps === void 0 ? void 0 : cardProps.logoAlt) || cardProps.name).concat(intl.formatMessage({
                            id: "images.logo"
                        })),
                        layout: "intrinsic",
                        objectFit: "contain",
                        width: "794px",
                        height: "397px",
                        sx: {
                            marginBottom: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(24),
                            width: {
                                mobile: "184px",
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(283)
                            }
                        }
                    }),
                    cardProps.cityName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        component: "div",
                        sx: {
                            display: "flex",
                            mb: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(24)
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_location__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                gutterBottom: true,
                                component: "address",
                                sx: {
                                    fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(24),
                                    mx: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(12),
                                    display: "-webkit-box",
                                    WebkitLineClamp: "1",
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                },
                                children: cardProps.address1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: "summary",
                        color: "text.secondary",
                        sx: {
                            fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(24),
                            color: theme.palette.grey[50],
                            display: "-webkit-box",
                            WebkitLineClamp: "4",
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        children: cardProps.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                sx: {
                    justifyContent: "center",
                    mb: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(24),
                    p: 0,
                    mt: "auto"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: {
                        pathname: "/".concat(cardProps.linkName, "/").concat(cardProps.slug),
                        query: {
                            cityId: browserCityId
                        }
                    },
                    passHref: true,
                    prefetch: _constants_prefetch__WEBPACK_IMPORTED_MODULE_13__/* .ALLOW_CINEMA_DETAILS_PREFETCH */ .Cz,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "contained",
                        sx: {
                            fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(16),
                            width: "178px",
                            height: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(56),
                                mobile: "56px"
                            },
                            borderRadius: "16px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            id: "global.explore"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardComponent);


/***/ }),

/***/ 16504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconLocation */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);
/* harmony import */ var _image_box_future__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58718);



var locationIcon = "/icons/shared/location-icon-blue.svg";
var IconLocation = function() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_1__/* .ImageBoxFuture */ .z, {
        img: locationIcon,
        title: intl.formatMessage({
            id: "images.title.location"
        }),
        objectFit: "contain",
        debug: false,
        sx: {
            width: "24px",
            height: "24px"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconLocation);


/***/ }),

/***/ 47488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gr": function() { return /* reexport */ useGetCinemaDetails; },
  "ve": function() { return /* reexport */ useGetCinemaList; },
  "L8": function() { return /* reexport */ useGetCinemas; }
});

// UNUSED EXPORTS: getCinemaList, useGetCinema

// EXTERNAL MODULE: ./src/logic/libs/index.ts
var libs = __webpack_require__(81900);
// EXTERNAL MODULE: ./src/constants/cashing.ts
var cashing = __webpack_require__(29236);
;// CONCATENATED MODULE: ./src/logic/services/cinemas/services.ts



var url = "cinemas";
var getCinemaList = function(params) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return axiosInstance.get("".concat(url), _object_spread({
        params: params
    }, config)).then(function(res) {
        return res === null || res === void 0 ? void 0 : res.data;
    });
};
var useGetCinemaList = (0,libs/* createQuery */.rP)({
    url: "".concat(url),
    method: "get"
}, {
    staleTime: cashing/* long_term_cashing */.d,
    keepPreviousData: false
});
var useGetCinemaDetails = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url, "/unique-name/:slug")
});
var useGetCinemas = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url)
}, {
    staleTime: cashing/* long_term_cashing */.d,
    keepPreviousData: false
});
var useGetCinema = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url, "/unique-name/:slug")
});

;// CONCATENATED MODULE: ./src/logic/services/cinemas/index.ts




/***/ }),

/***/ 60240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cinema": function() { return /* binding */ Cinema; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21214);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(96514);
/* harmony import */ var _logic_services_cinemas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47488);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44012);
/* harmony import */ var _components_seo_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89183);
/* harmony import */ var _constants_seo_pages_enum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33224);
/* harmony import */ var _logic_helpers_find_seo_inside_page__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36575);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43795);
/* harmony import */ var _logic_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7663);
/* harmony import */ var _logic_services_seo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97016);
/* harmony import */ var _components_shared_card_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27026);
/* harmony import */ var _components_shared_movie_loader_wrapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75884);















var emptyCinemaImgCard = "/icons/cinema/emptyCinemaImgCard.svg";
var __N_SSP = true;
var Cinema = function(param) {
    var serverCityId = param.serverCityId, path = param.path;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    var ref = (0,_logic_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useCity */ .hA)(), clientCityId = ref.cityId;
    var cityId = clientCityId || serverCityId;
    var ref1 = (0,_logic_services_cinemas__WEBPACK_IMPORTED_MODULE_2__/* .useGetCinemaList */ .ve)({
        params: {
            cityId: cityId
        }
    }), pageData = ref1.data;
    var ref2 = (0,_logic_services_seo__WEBPACK_IMPORTED_MODULE_7__/* .useGetPagesSeoMeta */ ._)(), seoDataList = ref2.data, isLoading = ref2.isLoading;
    var seoPage = (0,_logic_helpers_find_seo_inside_page__WEBPACK_IMPORTED_MODULE_12__/* .findSeoInsidePage */ .W)(seoDataList === null || seoDataList === void 0 ? void 0 : seoDataList.pageMetaData, _constants_seo_pages_enum__WEBPACK_IMPORTED_MODULE_4__/* .SeoPagesEnum.cinemas */ .E.cinemas);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo_seo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: (seoPage === null || seoPage === void 0 ? void 0 : seoPage.titleTag) || intl.formatMessage({
                    id: "cinema"
                }),
                canonical: seoPage === null || seoPage === void 0 ? void 0 : seoPage.canonicalURL,
                pagePath: path,
                description: seoPage === null || seoPage === void 0 ? void 0 : seoPage.descriptionTag,
                noFollow: seoPage === null || seoPage === void 0 ? void 0 : seoPage.hasFollow,
                noIndex: seoPage === null || seoPage === void 0 ? void 0 : seoPage.hasIndex,
                components: function() {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script" // hubspot new script
                    , {
                        type: "text/javascript",
                        id: "hs-script-loader",
                        async: true,
                        defer: true,
                        src: "//js-eu1.hs-scripts.com/143790225.js"
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                component: "section",
                maxWidth: "muviFixedContainer",
                sx: {
                    paddingX: {
                        mobile: "16px",
                        tablet: "30px",
                        mediumDesktop: "90px"
                    },
                    marginBottom: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(122)
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        component: "h1",
                        sx: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(30),
                            color: theme.palette.grey[80],
                            my: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(52),
                            fontWeight: 700
                        }, theme.breakpoints.down("tablet"), {
                            mt: "32px",
                            mb: "24px"
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            id: "cinema"
                        })
                    }),
                    !isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
                            container: true,
                            rowSpacing: {
                                mobile: "16px",
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(48)
                            },
                            columnSpacing: {
                                mobile: "0px",
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(46)
                            },
                            children: pageData === null || pageData === void 0 ? void 0 : pageData.cinema.map(function(cinema, index) {
                                var ref;
                                /*#__PURE__*/ return (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    in: true,
                                    style: {
                                        transformOrigin: "0 0 0"
                                    },
                                    timeout: 1000 + index * 500,
                                    key: cinema.id
                                }, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
                                    item: true,
                                    mobile: 12,
                                    tablet: 6,
                                    laptop: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_card_component__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        image: cinema.image || emptyCinemaImgCard,
                                        name: cinema.name,
                                        description: cinema.description,
                                        slug: cinema.uniqueName,
                                        cityName: cinema === null || cinema === void 0 ? void 0 : (ref = cinema.city) === null || ref === void 0 ? void 0 : ref.name,
                                        address1: cinema.address1,
                                        linkName: "cinemas",
                                        alt: (cinema === null || cinema === void 0 ? void 0 : cinema.imageAlt) || (cinema === null || cinema === void 0 ? void 0 : cinema.name)
                                    })
                                }));
                            })
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_movie_loader_wrapper__WEBPACK_IMPORTED_MODULE_9__/* .MovieLoaderWrapper */ .Y, {
                        innerBox: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            width: "160px",
                            height: "160px"
                        }, theme.breakpoints.down("laptop"), {
                            width: "100px",
                            height: "100px"
                        }),
                        outerBox: {
                            width: "100%",
                            height: {
                                mobile: "calc(100vh - 56px)",
                                tablet: "calc(100vh - 100px)"
                            },
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Cinema);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6886,4541,9774,2888,179], function() { return __webpack_exec__(8653); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);